<template>
	<!--svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
	    <g fill="none" fill-rule="nonzero">
	        <path fill="#FBBB00" d="M3.99 10.878l-.627 2.339-2.29.048A8.96 8.96 0 0 1 0 9c0-1.492.363-2.9 1.006-4.139l2.04.374.893 2.026A5.35 5.35 0 0 0 3.649 9c.001.66.12 1.294.34 1.878z"/>
	        <path fill="#518EF8" d="M17.843 7.319a9.01 9.01 0 0 1-.04 3.56 8.998 8.998 0 0 1-3.169 5.14v-.001l-2.568-.131-.363-2.269a5.364 5.364 0 0 0 2.307-2.739H9.198V7.32h8.645z"/>
	        <path fill="#28B446" d="M14.634 16.018A8.962 8.962 0 0 1 9 18a8.999 8.999 0 0 1-7.927-4.735l2.916-2.387a5.351 5.351 0 0 0 7.713 2.74l2.932 2.4z"/>
	        <path fill="#F14336" d="M14.745 2.072l-2.916 2.387A5.353 5.353 0 0 0 3.94 7.26l-2.932-2.4A8.998 8.998 0 0 1 9 0c2.184 0 4.186.778 5.745 2.072z"/>
	    </g>
	</svg!-->
	<img src='./google@3x.png'>
</template>

<script>
	export default {
		name: 'gcolorized'
	}
</script>